import React from "react";
import "./DashboardCard.css";

export default function DashboardCard({ title="Title", value="$0.00", variant="c1" }) {
  return (
    <div className={`card ${variant}`}>
      <div className="card-title">{title}</div>
      <div className="card-value">{value}</div>
    </div>
  );
}
